/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, DestroyRef, Input, OnInit, inject} from '@angular/core';

import template from './campaign-list-page.component.html';
import {SignalAdminListColumn, SignalAdminResourceListStateFactory} from '../common/controller/signal-admin-resource-list-state';
import {LineItemBulkActionService} from '../line-item/line-item-bulk-action.service';
import {LineItemApiService, LineItemModel} from '../line-item/line-item-api.service';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';
import {AdvertisingSharedModule} from '../advertising/advertising-shared.module';

@Component({
  standalone: true,
  imports: [AdvertisingSharedModule],
  selector: 'adn-campaign-list-page',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CampaignListPageComponent implements OnInit {
  readonly itemStateName = 'app.adv.campaigns.campaign';
  readonly productItemStateName = 'app.adm.products.product';
  readonly userItemStateName = 'app.adm.users.user';

  readonly columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {param: 'userState'},
    {param: 'executionState'},
    {param: 'startDate'},
    {param: 'endDate'},
    {param: 'objectives', numeric: true},
    {param: 'updateTime'}
  ];

  readonly list = inject(SignalAdminResourceListStateFactory).create<LineItemModel>(
    inject(LineItemApiService),
    {listId: 'Campaign', baseTable: 'lineItem', additionalParams: {excludeIfMissing: 'productId'}},
    inject(DestroyRef)
  );

  private readonly permissions = inject(LocalUserPermissions);
  private readonly lineItemApi = inject(LineItemApiService);
  private readonly lineItemBulkActionService = inject(LineItemBulkActionService);

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  userLinkDisabled(): boolean {
    const perms = this.permissions.getAllVisPermissions();
    return perms.MANAGE_SYSTEM !== true
      && perms.AX_ADVERTISER_ADMIN !== true
      && perms.AX_ADVERTISER_TEAM_ADMIN !== true;
  }

  ngOnInit(): void {
    this.list.load();
  }

  openBulkActions(): void {
    this.lineItemBulkActionService.createBulkAction({
      bulkSelection: this.list.selected(),
      miscBulkAction: (modal: any, controller: any, items: Partial<LineItemModel>[], _resource: any, params: any) => {
        this.lineItemApi.bulkSave(params || {}, items).subscribe({
          next: () => {
            modal.close();
            this.list.deselectAll();
            this.list.load();
          },
          error: () => {
            controller.form = controller.form || {};
            controller.form.bulkError = true;
          }
        });
      }
    })();
  }
}
